import { render, staticRenderFns } from "./reuse-tab.vue?vue&type=template&id=b07ec29c&scoped=true&"
import script from "./reuse-tab.vue?vue&type=script&lang=js&"
export * from "./reuse-tab.vue?vue&type=script&lang=js&"
import style0 from "./reuse-tab.vue?vue&type=style&index=0&id=b07ec29c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07ec29c",
  null
  
)

export default component.exports